import api from './api';

/**
 * @param {string} levelId
 * @param {string} testName
 * @param {string} qpvSetName
 * @param {string[]} testIds
 * @returns {Promise<{
 *  test_group_id: string
 *  name: string
 *  qpvSet: string
 *  tests: {
 *      test_id: string
 *      is_published: boolean
 *      skill_id: 'speaking' | 'reading_writing' | 'listening'
 *      test_group_id: string
 *  }[]
 *  test_focuses_thresholds: {
 *      tf_threshold_id: string
 *      threshold: number
 *      tf_id: string
 *      test_group_id: string
 *  }[]
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-TestGroups-postTestGroups
 */
export default async function createNewTest(levelId, testName, qpvSetName, testIds) {
    const { data } = await api.post(
        `/levels/${levelId}/test_groups`, {
            name: testName,
            status: 'draft',
            qpvSet: qpvSetName,
            test_ids: testIds
        }
    );

    return data;
}